"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("./Utils");
const Record_1 = require("./Record");
// Handle
exports.RT_HANDLE = Symbol("RT:HANDLE");
class Handle {
    constructor(stateless, proxy, virtualization) {
        this.stateless = stateless;
        this.id = ++Handle.id;
        this.proxy = proxy || new Proxy(this, virtualization);
        this.hint = stateless.constructor.name;
        this.head = Record_1.Record.empty;
        this.changing = undefined;
        this.writers = 0;
    }
    static setHint(obj, hint) {
        if (hint) {
            const h = Utils_1.Utils.get(obj, exports.RT_HANDLE);
            if (h)
                h.hint = hint;
        }
        return obj;
    }
    static getHint(obj) {
        const h = Utils_1.Utils.get(obj, exports.RT_HANDLE);
        return h ? h.hint : undefined;
    }
}
exports.Handle = Handle;
Handle.id = 20;
